import { marked } from "marked";

const FAQInnerOne = (props) => {
  const { visionObjectiveHeader, visionData, objectiveData } = props;
  return (
    <section className="faq-page pb-120">
      <div className="container">
        <div className="section-heading text-center" id="visionobjectiveheader">
          <div className="flex-align d-inline-flex gap-8 mb-16">
            <span className="text-main-600 text-2xl d-flex">
              <i className="ph-bold ph-book-open" />
            </span>
            <h5 className="text-main-600 mb-0">
              {visionObjectiveHeader[0]?.snippet}
            </h5>
          </div>
          <h2 className="mb-24">{visionObjectiveHeader[0]?.title}</h2>
          <p className="">{visionObjectiveHeader[0]?.description}</p>
        </div>
        {/* <div className='text-center mb-40'>
          <ul
            className='nav nav-pills common-tab custom-padding d-inline-flex gap-16 bg-white p-12 border border-neutral-30 rounded-pill'
            id='pills-tab'
            role='tablist'
          >
            <li className='nav-item' role='presentation'>
              <button
                className='nav-link rounded-pill bg-main-25 text-md fw-medium text-neutral-500 flex-center w-100 gap-8 active'
                id='pills-onlineEdu-tab'
                data-bs-toggle='pill'
                data-bs-target='#pills-onlineEdu'
                type='button'
                role='tab'
                aria-controls='pills-onlineEdu'
                aria-selected='true'
              >
                <i className='text-xl text-main-600 d-flex ph-bold ph-user' />
                Online Education
              </button>
            </li>
            <li className='nav-item' role='presentation'>
              <button
                className='nav-link rounded-pill bg-main-25 text-md fw-medium text-neutral-500 flex-center w-100 gap-8'
                id='pills-paymentMethod-tab'
                data-bs-toggle='pill'
                data-bs-target='#pills-paymentMethod'
                type='button'
                role='tab'
                aria-controls='pills-paymentMethod'
                aria-selected='false'
              >
                <i className='text-xl text-main-600 d-flex ph-bold ph-graduation-cap' />
                Payment Method
              </button>
            </li>
            <li className='nav-item' role='presentation'>
              <button
                className='nav-link rounded-pill bg-main-25 text-md fw-medium text-neutral-500 flex-center w-100 gap-8'
                id='pills-Pricing-tab'
                data-bs-toggle='pill'
                data-bs-target='#pills-Pricing'
                type='button'
                role='tab'
                aria-controls='pills-Pricing'
                aria-selected='false'
              >
                <i className='text-xl text-main-600 d-flex ph-bold ph-star' />
                Pricing Plan
              </button>
            </li>
          </ul>
        </div> */}
        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-onlineEdu"
            role="tabpanel"
            aria-labelledby="pills-onlineEdu-tab"
            tabIndex={0}
          >
            <div className="row gy-4">
              <div className="col-lg-6">
                <div className="join-community__content" id="vision">
                  <div className="mb-40">
                    <h2 className="mb-24 wow bounceIn">Vision</h2>
                    <p className="text-neutral-500 text-line-2 wow bounceInUp">
                      {visionData[0]?.description}
                    </p>
                  </div>
                  <div className="join-community__thumb text-end position-relative">
                    <img
                      src={
                        visionData[0]?.image[0]?.media?.url &&
                        `${process.env.REACT_APP_cmsUrl}${visionData[0]?.image[0]?.media?.url}`
                      }
                      alt="join-community-img"
                      className="wow bounceIn"
                      data-tilt=""
                      data-tilt-max={12}
                      data-tilt-speed={500}
                      data-tilt-perspective={5000}
                      data-tilt-full-page-listening=""
                    />
                    {/* <div className="offer-message style-two px-24 py-12 rounded-12 bg-white fw-medium flex-align d-inline-flex gap-16 box-shadow-lg animation-upDown">
                    <span className="banner-box__icon flex-shrink-0 w-48 h-48 bg-purple-400 text-white text-2xl flex-center rounded-circle">
                      <i className="ph-bold ph-users" />
                    </span>
                    <div className="text-start">
                      <h6 className="mb-4">56K</h6>
                      <span className="">All Students</span>
                    </div>
                  </div> */}
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-26">
                  <h2 className="mb-24 wow bounceIn">Objectives</h2>
                </div>
                <div
                  className="accordion common-accordion wow bounceIn"
                  id="accordionExampleTwooo"
                >
                  {objectiveData?.map((objective, index) => {
                    const collapseId = `collapseObjective${index}`;
                    const headingId = `headingObjective${index}`;
                    const isFirst = index === 0;
                    marked.setOptions({ gfm: true, breaks: true });

                    const description = objective?.description || "";

                    const content = marked(description);
                    const html = content.startsWith("<ul>")
                      ? content
                      : `<ul>${content}</ul>`;

                    return (
                      <div
                        className="accordion-item"
                        key={index}
                        id={`objective${objective.id}`}
                      >
                        <h2 className="accordion-header" id={headingId}>
                          <button
                            className={`accordion-button ${
                              !isFirst ? "collapsed" : ""
                            }`}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#${collapseId}`}
                            aria-expanded={isFirst ? "true" : "false"}
                            aria-controls={collapseId}
                          >
                            {objective?.title}
                          </button>
                        </h2>
                        <div
                          id={collapseId}
                          className={`accordion-collapse collapse ${
                            isFirst ? "show" : ""
                          }`}
                          data-bs-parent="#accordionExampleTwooo"
                        >
                          <div className="accordion-body">
                            <p
                              className="accordion-body__desc"
                              dangerouslySetInnerHTML={{
                                __html: html,
                              }}
                            ></p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQInnerOne;
